var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chip-container",style:({
    color: _vm.turnOn ? _vm.color : _vm.bkColor,
    backgroundColor: _vm.turnOn ? _vm.bkColor : _vm.color,
    border: `solid 1px ${_vm.borderColor}`,
  }),on:{"click":_vm.onClick}},[_c('p',{staticClass:"chip-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.withArrow && (_vm.isArrowUp || _vm.isArrowDown))?_c('div',{staticClass:"chip-arrow"},[(_vm.isArrowUp)?_c('IconArrowUp',{attrs:{"fill":_vm.color}}):(_vm.isArrowDown)?_c('IconArrowDown',{attrs:{"fill":_vm.color}}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }